import { Carousel as LibCarousel } from "react-bootstrap";
import EventsCarouselCard from "./EventsCarouselCard/EventsCarouselCard";
import styles from "./EventsCarousel.module.scss";
import { uuid } from "lib/utils";
import useEvents from "lib/hooks/useEvents";
import { LoadingSpinner } from "lib/Spinner";
import { NotAvailable } from "lib/SimpleTable";
import { useMemo } from "react";

function EventsCarousel() {
  const { isLoading, error, carouselEvents } = useEvents(undefined, false);

  const carousel = useMemo(() => {
    return (
      <LibCarousel defaultActiveIndex={0} controls={false} fade className={styles.container} interval={2500}>
        {carouselEvents.map((event, idx) => {
          const finalTheme = getFinalTheme(idx);
          const key = uuid(event.eventId);

          return (
            <LibCarousel.Item key={key}>
              <EventsCarouselCard {...event} theme={finalTheme} />
            </LibCarousel.Item>
          );
        })}
      </LibCarousel>
    );
  }, [carouselEvents.length]);

  if (isLoading) return <LoadingSpinner />;
  if (error) return <NotAvailable />;
  if (!carouselEvents.length) return <NoEventsFound />;

  return carousel;
}

function getFinalTheme(idx) {
  const odd = idx % 2 === 0;
  return odd ? "gray" : "maroon";
}

function NoEventsFound() {
  return <div className={styles.noEventsFound}>No Events Found</div>;
}

export default EventsCarousel;
